import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import { venomHistory } from 'client/utils/history/venom-history';
import { Link } from 'site-modules/shared/components/link/link';

import './page-size-select.scss';

export function PageSizeSelect({
  buildPageSizeLink,
  currentSize,
  pageSizes,
  dataTrackingId = null,
  addLoading = noop,
  useVenomHistory = false,
}) {
  function onClick({
    currentTarget: {
      dataset: { size },
    },
  }) {
    addLoading();

    setTimeout(() => {
      venomHistory.push(buildPageSizeLink(size));
    }, 0);
  }

  return (
    <Row className="page-size-select medium text-gray-darker hidden-md-down">
      <Col md={12} xl="auto" className="ms-md-1 ms-xl-0 p-xl-0">
        Items per page:
      </Col>
      <Col md={12} xl="auto" className="p-xl-0 d-flex align-items-center">
        {pageSizes.map(size => {
          const LinkComponent = useVenomHistory ? Button : Link;
          const linkProps = useVenomHistory
            ? {
                onClick,
                color: 'link',
                'data-size': size,
              }
            : {
                to: buildPageSizeLink(size),
                rel: 'nofollow',
              };

          return size === currentSize ? (
            <span key={`page-size-${size}`} className="size-link fw-bold px-1">
              {size}
            </span>
          ) : (
            <LinkComponent
              {...linkProps}
              key={`page-size-${size}`}
              className="size-link fw-normal bg-transparent px-1 py-0"
              aria-label={`Set ${size} items per page`}
              data-tracking-id={dataTrackingId}
            >
              {size}
            </LinkComponent>
          );
        })}
      </Col>
    </Row>
  );
}

PageSizeSelect.propTypes = {
  buildPageSizeLink: PropTypes.func.isRequired,
  currentSize: PropTypes.number.isRequired,
  pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
  dataTrackingId: PropTypes.string,
  addLoading: PropTypes.func,
  useVenomHistory: PropTypes.bool,
};
